import api from "@/lib/api";

// Driver e-signature capture: upload a captured PNG (typed or drawn), read back the current
// signature on file, and load a signature image as an authenticated blob URL for <img> use.

export async function uploadSignature(driverId, { method, typedName, blob, purpose }) {
  const fd = new FormData();
  fd.append("method", method);
  fd.append("typed_name", typedName);
  if (purpose) fd.append("purpose", purpose);
  fd.append("file", blob, "signature.png");
  const { data } = await api.post(`/drivers/${driverId}/signatures`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function listSignatures(driverId) {
  const { data } = await api.get(`/drivers/${driverId}/signatures`);
  return data;
}

export async function getCurrentSignature(driverId) {
  try {
    const { data } = await api.get(`/drivers/${driverId}/signatures/current`);
    return data;
  } catch (e) {
    if (e.response?.status === 404) return null;
    throw e;
  }
}

// Returns a blob: URL the caller must revoke (URL.revokeObjectURL) once it is no longer shown.
export async function fetchSignatureImage(sigId) {
  const { data } = await api.get(`/drivers/signatures/${sigId}/image`, { responseType: "blob" });
  return URL.createObjectURL(data);
}
